<script>
import api from './api'
import AcceptButton from './AcceptButton'
import AnswerForm from './AnswerForm'
import BasePopover from './BasePopover'
import FileOrPicture from './FileOrPicture'
import FilesList from './FilesList'
import QuestionEdit from './QuestionEdit'
import SubmitTriggerButton from '../../shared/SubmitTriggerButton'
import VoteComponent from './VoteComponent'
import FollowPopover from './FollowPopover'
import VotePopover from './VotePopover'
import StyleguideComponents from '../../shared/index'

export default {
	name: 'QuestionEdit',
    components: {
        AcceptButton,
        AnswerForm,
        BasePopover,
        FileOrPicture,
        FilesList,
        QuestionEdit,
        SubmitTriggerButton,
        VoteComponent,
        VotePopover,
        FollowPopover,
        ...StyleguideComponents
    },
	data: function () {
		return {
			'isNew': false,
			'isLoading': false,
			'loadingStatus': false,
			'publishedUrl': false,
			member: {
				name: '',
				cached_slug: ''
			},
			recaptchaResponse: null,
			question: {
				id: null,
				group_id: null,
				cached_slug: null,
				title: '',
				content_category_id: null,
				content: '',
				system_id: null,
				tags: [],
				files: {
					files: [],
					deleted: []
				}
			},
			options: {
				categoryOptions: [],
				softwareOptions: [],
				designCategories: []
			},
			validationErrors: {
				validatedOnce: false,
				question: {
					title: null,
					content: null,
					content_category_id: null,
					system_id: null
				}
			}
		};
	},
	props: ['questionId'],
	computed: {
		isDesignCategory: function () {
			let category = this.question.content_category_id;
			return this.options.designCategories.indexOf(category) >= 0;
		},
		contentCategory: {
			get: function () {
				return this.options.categoryOptions.filter(option => {
					return option.value === this.question.content_category_id;
				})[0];
			},
			set: function (selected) {
				this.$set(this.question, 'content_category_id', selected.value);
			}
		},

		system: {
			get: function () {
				return this.options.softwareOptions.filter(option => {
					return option.value === this.question.system_id;
				})[0];
			},
			set: function (selected) {
				this.$set(this.question, 'system_id', selected.value);
			}
		},
		inGroup: function () {
			return this.question.group_id && this.question.group_id.length > 0;
		}
	},
	methods: {
		validateSave: function () {
			this.validate();
			this.$set(this.validationErrors, 'validatedOnce', true);
			const errorsList = Object.keys(this.validationErrors.question).filter(key => {
				return this.validationErrors.question[key];
			});

			if (!errorsList.length) {
				this.isLoading = true;

				if (!this.question.id) {
					if (this.recaptchaCheckNeeded()) {
						this.isLoading = false;
						return window.grecaptcha.execute();
					}

					api.createQuestion(this.question, this.recaptchaResponse)
						.then(this.handleSaveSuccess)
						.catch(this.handleRequestError);

				} else {
					api.updateQuestion(this.question)
						.then(this.handleSaveSuccess)
						.catch(this.handleRequestError);
				}
			}
		},
		getFilters: function () {
			api.fetchFilters().then(data => {
				this.$set(this.options, 'categoryOptions', data.category_options);
				this.$set(this.options, 'softwareOptions', data.software_options);
				this.$set(this.options, 'designCategories', data.design_categories);
			});
		},
		getQuestionData: function () {
			if (this.questionId) {
				api.fetchQuestion(this.questionId).then((data) => {
					this.$set(this.question, 'id', data.id);
					this.$set(this.question, 'cached_slug', data.cached_slug);
					this.$set(this.question, 'title', data.title);
					this.$set(this.question, 'content', data.content);
					this.$set(this.question, 'system_id', data.system_id);
					this.$set(this.question, 'tags', data.tags);
					this.$set(this.question.files, 'files', data.files);
					this.$set(this.question, 'content_category_id', data.content_category_id);
				});
			}
		},
		handleSaveSuccess: function (data) {
			this.isLoading = false;
			if (Grabcad.currentGroup) {
				location.pathname = '/groups/' + Grabcad.currentGroup + '/questions/' + data.cached_slug;
			} else {
				location.pathname = '/questions/' + data.cached_slug;
			}
		},
		handleRequestError: function (err) {
			this.isLoading = false;
			this.$eventHub.$emit('addAlert', {
				type: 'error',
				message: 'Something went wrong'
			});
			Raygun && Raygun.send(err);
		},
		validate: function () {
			let questionValue = !this.question.title.length;
			let contentValue = !this.question.content.length;
			let categoryValue = !this.question.content_category_id;
			let systemValue = this.isDesignCategory && !this.question.system_id;

			this.$set(this.validationErrors.question, 'title', questionValue);
			this.$set(this.validationErrors.question, 'content', contentValue);
			if (this.inGroup) return;
			this.$set(this.validationErrors.question, 'content_category_id', categoryValue);
			this.$set(this.validationErrors.question, 'system_id', systemValue);
		},

		recaptchaCallback: function (response) {
			this.recaptchaResponse = response;
			this.validateSave();
		},

		recaptchaCheckNeeded () {
			return window.grecaptcha && !window.grecaptcha.getResponse();
		}
	},
	mounted: function () {
		this.getFilters();
		this.getQuestionData();
		this.member = Grabcad.member || {};
		this.question.group_id = Grabcad.currentGroup;
		window.recaptchaCallback = this.recaptchaCallback;
	},
	watch: {
		question: {
			handler: function () {
				if (this.validationErrors.validatedOnce) {
					this.validate();
				}
			},
			deep: true
		}
	}
}
</script>
